import Modal from "../../../../common/modal/Modal";

const CreateLinksModal = ( { baseURL, orgID, refetch } ) => {

    async function SaveOrgsLinks( infos, orgID ) {
        const currentRestUrl = window.group_dashboard.base
        const nonce = window.group_dashboard.nonce
    
        const url = currentRestUrl + 'membersync/licensing/v1/org/' + orgID + '/links'
      
        await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'infos': JSON.stringify(infos),
              'base_url': baseURL
            }),
            headers:{
              'X-WP-Nonce': nonce,
              'Content-type': 'application/json'
            }
        }).then(resp => {
            return resp.json()
        })
        .then((json) => {
        })
    }

    return (
        <div>
            <Modal 
                modalId="msync-org-create-invites-links" 
                modalHeading="Create invitation link"
                buttonTitle=''
                modalClassNames={'msync-members-custom-modal msync-members-custom-modal-border'}
            >
                <main className="msync-modal__body">
                    <div>Create custom invitation links. Users who click these links will be able to join your organization without an invitation.</div>
                    <div>
                        {
                            tangibleFields.render({
                              name: 'link-infos',
                              type: 'repeater',
                              layout: 'table',
                              wrapper: {
                                class: 'msync-new-org-invites-reapeater'
                              },
                              fields: [
                                {
                                    name: 'arguments',
                                    type: 'text',
                                    prefix: baseURL
                                },
                                {
                                    name: 'preset',
                                    type: 'combo-box',
                                    isAsync: true,
                                    ajaxAction: 'get_presets',
                                    asyncArgs: {
                                    type: 'member',
                                    org: orgID
                                    }
                                }
                              ]
                            })
                        }
                    </div>
                </main>
                <footer className="msync-modal__footer">
                    <input 
                        type="button" 
                        value="Save" 
                        className="msync-button"
                        onClick={ async () => {
                            const infos = tangibleFields.store.getValue('link-infos')
                            await SaveOrgsLinks( infos, orgID )
                            refetch()
                        }} 
                    />
                </footer>
            </Modal>
        </div>
    );
};

export default CreateLinksModal;
